import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ModalOptions } from '@mapfre-design-library/src/public_api';
import { PolicyDataService } from '../../../../../../_services/data-services/policy-data.service';
import { Location } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, MapfreButtonComponent],
  selector: 'app-information-not-match',
  templateUrl: './information-not-match.component.html',
})
export class InformationNotMatchComponent implements OnInit {
  whereToFindModalOptions: ModalOptions;
  uploadingFiles: ModalOptions;
  userData;
  policyNumber: string;
  zipCode: string;
  constructor(
    private policyDataService: PolicyDataService,
    private location: Location
  ) {
    this.uploadingFiles = new ModalOptions({
      additionalClasses: 'modal-lg modal-dialog center-on-page confirm-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'policyEmailDoesnotMatchEmail',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: '',
      modalName: 'policy_email_doesnot_match_email',
    });
  }
  ngOnInit() {
    this.policyNumber = this.policyDataService.getPolicyNumber();
    this.zipCode = this.policyDataService.getZipCode();
  }
  goBack() {
    this.location.back();
  }
}
